import { AuthObject } from '@issuemanager/legacy/common';
import { LaunchpadUser } from './types';
import {
  stagingSolarisTestingOrganization,
  devSandboxOrganization,
  devSolarisMonitoringOrganization,
  localSandboxOrganization,
  productionBudapestTestOrganization,
  authorizationTestOrganization,
} from '../test-organizations/issue-manager-test-organizations';
import { riskManagerOrganization } from '../test-organizations/risk-manager-test-organizations';

// Production users
export const productionAdminTestUser: LaunchpadUser = {
  email: 'jzabala+admin@diligent.com',
  password: 'asdQWE123',
  name: 'Javier Zabala',
  firstName: 'Javier',
  lastName: 'Zabala',
  initials: 'JZ',
  highbondId: 'ScmNozWdshzvNGk5THG7',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '7a49c3d2-a172-4b07-ab19-4a97ed107ac0',
  organization: productionBudapestTestOrganization,
};

export const productionTestUser: LaunchpadUser = {
  email: 'jzabala+user@diligent.com',
  password: 'asdQWE123',
  name: 'Javier Zabala',
  firstName: 'Javier',
  lastName: 'Zabala',
  initials: 'JZ',
  highbondId: 'HaYCVgX7nGSGQ-_KpUzp',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '7a49c3d2-a172-4b07-ab19-4a97ed107ac1',
  organization: productionBudapestTestOrganization,
};

// Staging users
export const stagingAdminTestUser: LaunchpadUser = {
  email: 'jzabala+test@diligent.com',
  password: 'asdQWE123',
  name: 'Javier Zabala',
  firstName: 'Javier',
  lastName: 'Zabala',
  initials: 'JZ',
  highbondId: 'yGdcH_dxTPjM5usxJz8D',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '7a49c3d2-a172-4b07-ab19-4a97ed107ac0',
  organization: stagingSolarisTestingOrganization,
};

export const stagingTestUser: LaunchpadUser = {
  email: 'jzabala+test-user@diligent.com',
  password: 'asdQWE123',
  name: 'Javier Zabala',
  firstName: 'Javier',
  lastName: 'Zabala',
  initials: 'JZ',
  highbondId: 'Xjoz9kkRmuHRtvuppX_f',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '7a49c3d2-a172-4b07-ab19-4a97ed107ac1',
  organization: stagingSolarisTestingOrganization,
};

// Dev environment users
export const devAdminTestUser: LaunchpadUser = {
  email: 'jzabala+test-admin@diligent.com',
  password: 'asdQWE123',
  name: 'JavierAdmin Zabala',
  firstName: 'JavierAdmin',
  lastName: 'Zabala',
  initials: 'JZ',
  highbondId: 'naSMQEm9yDqP4LYFshxe',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'admin',
  id: '7a49c3d2-a172-4b07-ab19-4a97ed107aca',
  organization: devSandboxOrganization,
  secondaryOrganizations: [riskManagerOrganization],
};

export const devTestUser: LaunchpadUser = {
  email: 'jzabala+test-regular@diligent.com',
  password: 'asdQWE123',
  name: 'Javier Zabala',
  firstName: 'Javier',
  lastName: 'Zabala',
  initials: 'JZ',
  highbondId: 'jD7RAv3Zxr6ysWHSmwqj',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '7a49c3d2-a172-4b07-ab19-4a97ed107acf',
  organization: devSandboxOrganization,
  secondaryOrganizations: [riskManagerOrganization],
};

export const devMonitoringUser: LaunchpadUser = {
  email: 'ddaradics+monitoring@diligent.com',
  password: 'asdQWE123',
  name: 'David Daradics',
  firstName: 'David',
  lastName: 'Daradics',
  initials: 'DD',
  highbondId: 'GYW2JYGhseRzdQ3sGWLN',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '98519a59-a041-4b81-b116-95fee7db1069',
  organization: devSolarisMonitoringOrganization,
};

// Local environment users (with AuthObject)
export const localTestUser: LaunchpadUser & AuthObject = {
  highbondId: 'localHighbondId',
  email: 'local.test@example.com',
  name: 'local test',
  firstName: 'local',
  lastName: 'test',
  initials: 'LT',
  password: 'asdQWE123',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '74562189-6e3b-40b2-b0fe-72ad5416eacb',
  uid: 'localHighbondId',
  org_id: localSandboxOrganization.highbondId,
  jwt: 'localHighbondId',
  organization: localSandboxOrganization,
};

export const localAdminTestUser: LaunchpadUser & AuthObject = {
  highbondId: 'localAdminHighbondId',
  email: 'localadmin.test@example.com',
  name: 'localAdmin test',
  firstName: 'localAdmin',
  lastName: 'test',
  initials: 'LT',
  password: 'asdQWE123',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'admin',
  id: '74562189-6e3b-40b2-b0fe-72ad5416eacc',
  uid: 'localAdminHighbondId',
  org_id: localSandboxOrganization.highbondId,
  jwt: 'localAdminHighbondId',
  organization: localSandboxOrganization,
};

export const authorizationTestUser: LaunchpadUser & AuthObject = {
  highbondId: 'authorizationHighbondId',
  email: 'authorization.test@example.com',
  name: 'Authorization Test',
  firstName: 'Authorization',
  lastName: 'Test',
  initials: 'AT',
  password: 'asdQWE123',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '0192240a-2bfb-7e35-a09e-6b03cc542957',
  uid: 'authorizationHighbondId',
  org_id: authorizationTestOrganization.highbondId,
  jwt: 'authorizationHighbondId',
  organization: authorizationTestOrganization,
};

export const authorizationTestAdminUser: LaunchpadUser & AuthObject = {
  highbondId: 'authorizationAdminHighbondId',
  email: 'admin.authorization.test@example.com',
  name: 'Authorization Test Admin',
  firstName: 'Authorization',
  lastName: 'Test Admin',
  initials: 'AA',
  password: 'asdQWE123',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'admin',
  id: '0aa2aaaa-2bfb-7e35-a09e-6b03cc542957',
  uid: 'authorizationAdminHighbondId',
  org_id: authorizationTestOrganization.highbondId,
  jwt: 'authorizationAdminHighbondId',
  organization: authorizationTestOrganization,
};

// Environment-specific arrays for seeders
export const localIssueManagerTestUsers: LaunchpadUser[] = [
  localTestUser,
  localAdminTestUser,
  authorizationTestUser,
  authorizationTestAdminUser,
];

export const devIssueManagerTestUsers: LaunchpadUser[] = [
  devAdminTestUser,
  devTestUser,
  devMonitoringUser,
];
